var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListMarkerYellow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  fillRule: "evenodd",
  d: "M9 0a8.94 8.94 0 0 1 6.364 2.636A8.94 8.94 0 0 1 18 9a8.94 8.94 0 0 1-2.636 6.364A8.94 8.94 0 0 1 9 18a8.94 8.94 0 0 1-6.364-2.636A8.94 8.94 0 0 1 0 9c0-2.404.936-4.664 2.636-6.364A8.94 8.94 0 0 1 9 0m-.73 11.888 5.03-5.03a.527.527 0 1 0-.746-.746L7.897 10.77 5.446 8.318a.527.527 0 1 0-.746.745l2.824 2.825a.526.526 0 0 0 .746 0",
  clipRule: "evenodd"
})));
export default SvgListMarkerYellow;